import { apiFetch } from '../../services/http';

export type Profile = {
  username: string;
  displayName: string;
  bio: string;
  activeAlias: string;
  marketingOptIn: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export type AliasHistoryEntry = {
  topicId: string;
  alias: string;
  timestamp: string;
};

export async function fetchProfile(username: string): Promise<Profile> {
  return apiFetch<Profile>(`/api/profile/${encodeURIComponent(username)}`);
}

export async function updateProfile(username: string, payload: Partial<Profile>): Promise<Profile> {
  return apiFetch<Profile>(`/api/profile/${encodeURIComponent(username)}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export async function fetchAliasHistory(username: string): Promise<AliasHistoryEntry[]> {
  // Use auth service endpoint instead of profile service
  // Profile service uses in-memory storage, but aliases are stored in MySQL via auth service
  try {
    return await apiFetch<AliasHistoryEntry[]>(`/api/auth/aliases/history`);
  } catch (error) {
    console.error('Failed to fetch alias history:', error);
    return [];
  }
}
